import { render, staticRenderFns } from "./CanvasSourceGrid.vue?vue&type=template&id=1a8484ec&"
import script from "./CanvasSourceGrid.vue?vue&type=script&lang=ts&"
export * from "./CanvasSourceGrid.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  ,true
)

export default component.exports